import React, {Component} from 'react'
import Cabecalho from './cabecalho.js'
import Rodape from './rodape.js'
import TelaBemVindo from './telaBemvindo.js'
import TelaIncidente from './telaIncidente.js'
import TelaRelatarCliente from './telaRelatarCliente.js'
import TelaRelatarColaborador from './telaRelatarColaborador.js'
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

class Moldura extends Component {

    constructor(props) {
        super(props);
        this.state = {
            servidor: props.servidor
        }
    }

    render() {
        return(
            <div className="page">
                <Cabecalho servidor={this.state.servidor} />
                <div className="main main-bg">
                    <Router>
                        <div>
                            <Switch>
                                <Redirect from="/Bemvindo.aspx" to="/bemvindo" />
                                <Redirect from="/RelatarAdobe.aspx" to="/relatar" />
                                <Redirect from="/RelatarCrefisa.aspx" to="/relatar" />
                                <Redirect from="/RelatarToscana.aspx" to="/relatar" />
                                <Redirect from="/RelatarCliente.aspx" to="/relatarCliente" />
                            </Switch>
                            <Switch>
                                <Route exact path="/" render={() => <TelaRelatarColaborador servidor={this.state.servidor} />} />
                                <Route exact path={"/bemvindo"} render={ () => <TelaBemVindo servidor={this.state.servidor} /> } />
                                <Route exact path={"/relatar"} render={ () => <TelaRelatarColaborador servidor={this.state.servidor} /> } />
                                <Route exact path={"/relatarCliente"} render={ () => <TelaRelatarCliente servidor={this.state.servidor} /> } />
                                <Route path={"/incidente"} render={ () => <TelaIncidente servidor={this.state.servidor} /> } />
                                <Route render={ () => <TelaRelatarColaborador servidor={this.state.servidor} /> } />
                            </Switch>
                        </div>
                    </Router>
                </div>
                <Rodape servidor={this.state.servidor} />
            </div>
        )
    }
}
export default Moldura